<template>
  <span class="upload-btn icon icon-image">
    <input
      title="图片"
      v-if="!isMute"
      type="file"
      data-type="image"
      accept=".png,.jpeg,.jpg"
      @change="sendUploadMessage"
    />
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    isMute: {
      type: Boolean,
      default: () => false,
    },
    isH5: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    // 发送需要上传的消息：图片
    async sendUploadMessage(e) {
      if (this.isMute) return;
      if (e.target.files.length > 0) {
        try {
          const files = e.target.files[0];
          this.$emit("select", files);
        } catch (error) {
          console.log("sendUploadMessage", error);
        }
      }
      e.target.value = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-btn {
  margin-right: 20px;
  position: relative;
  display: block;
  width: 24px;
  height: 24px;
  background-image: url("../../../../assets/images/chat/image.png");
  background-size: 100%;
  cursor: pointer;
  input {
    position: absolute;
    cursor: pointer;
    left: 0;
    top: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
